
function setNullable(key: string, value: any) {
    if(value === null || value === undefined) {
        localStorage.removeItem(key);
    }

    localStorage.setItem(key, value);
}

enum StorageKeys {
    LastProfileId = "lastProfileId",
    LastProjectId = "lastProjectId",
}

class ClientStorage {

    get lastProfileId() : number | null {
        return +localStorage.getItem(StorageKeys.LastProfileId)! || null;
    }

    set lastProfileId(profileId: number | null) {
        setNullable(StorageKeys.LastProfileId, profileId);
    }

    get lastProjectId() : number | null {
        return +localStorage.getItem(StorageKeys.LastProjectId)! || null;
    }

    set lastProjectId(projectId: number | null) {
        setNullable(StorageKeys.LastProjectId, projectId);
    }
}


export default new ClientStorage();